import http, { url } from '../../http'

const API_URL = "sgsst-politic" 

class SGSSTPoliticAPI {

  async save(data) {
    const response = await http(`${API_URL}/save`, 'POST', data)
    return response
  }

  async getAll(companyID, page) {
    const response = await http(`${API_URL}/${companyID}?page=${page}`)
    return response || null
  } 

  getWord() {
    return url(`${API_URL}`)
  }

  async getLastSGSST(companyID) {
    const response = await http(`${API_URL}/show-recent-sgsst/${companyID}`)
    return response
  }
   
}

export default new SGSSTPoliticAPI()